import {useExpiredNoticeStore} from '@/root/stores/cardCarousel';

const CardExpiredNotice = () => {
  const visible = useExpiredNoticeStore((state) => state.visible);

  if (!visible) return null;

  return (
    <span className="item_expired">
      <span className="icon icon_notice4"></span>만료되었습니다
    </span>
  );
};
export default CardExpiredNotice;
